import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "phone-category-highlights"
}

import {
  inject,
} from 'vue';

import {
  injectionKeys
} from '@distancify/drapejs-litium';

import ImageWithFallback from '@/components/ImageWithFallback.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneCategoryHighlights',
  props: {
    category: null
  },
  setup(__props: any) {

const props = __props as {
  category: any
};

const toLitiumMediaUrl = inject(injectionKeys.toLitiumMediaUrlKey, () => '');




return (_ctx: any,_cache: any) => {
  return (props.category.highlights && props.category.highlights.length)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.category.highlights.filter((r) => r), (highlight) => {
          return (_openBlock(), _createBlock(ImageWithFallback, {
            key: highlight,
            image: _unref(toLitiumMediaUrl)(highlight, {
        fillArea: {
          height: 55,
          width: 55,
        }
      }),
            width: "55",
            height: "55"
          }, null, 8, ["image"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})